import styled from 'styled-components/native';

export default styled.View<{ inset?: number }>`
  height: 80px;
  margin-top: ${({ inset }) => (inset === 0 ? 20 : 0)}px;
  padding: ${({ inset }) => inset || 0}px 0 15px;
  flex-direction: row;
  align-items: center;
`;
